import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";

export default function GreatSchools(props) {
  const t = props.estatedProperty;
  return (
    <Paper sx={{ p: 2, display: "flex", flexDirection: "column" }}>
      <Typography variant="h6" color="primary" gutterBottom>
        GreatSchools rating
      </Typography>
      <Table size="small">
        <TableBody>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Distance</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Grades</TableCell>
            <TableCell>Rating</TableCell>
            <TableCell># Students</TableCell>
            <TableCell>Student Teacher Ratio</TableCell>
          </TableRow>
          {t.property_info.schools.map((school, index) => {
            let name = <TableCell>{school.name}</TableCell>;
            if (school.great_schools_url) {
              name = (
                <TableCell>
                  <a
                    href={school.great_schools_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {school.name}
                  </a>
                </TableCell>
              );
            }
            return (
              <TableRow key={index}>
                {name}
                <TableCell>{school.distance}</TableCell>
                <TableCell>{school.types}</TableCell>
                <TableCell>{school.grades_offered}</TableCell>
                <TableCell>{school.great_schools_rating}</TableCell>
                <TableCell>{school.student_count}</TableCell>
                <TableCell>{school.student_teacher_ratio}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </Paper>
  );
}
